import { render, staticRenderFns } from "./WorkerLanguagesForm.vue?vue&type=template&id=4485e25a&scoped=true&"
import script from "./WorkerLanguagesForm.vue?vue&type=script&lang=js&"
export * from "./WorkerLanguagesForm.vue?vue&type=script&lang=js&"
import style0 from "./WorkerLanguagesForm.vue?vue&type=style&index=0&id=4485e25a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4485e25a",
  null
  
)

export default component.exports